import { FC } from "react";
import { Divider } from "antd";
import { DiscountsItem } from "src/store/slices/item/subitems/discounts.types";
import { DiscountDetailsCard, Instructions } from "../components";
import DiscountChips from "../components/DiscountChips/DiscountChips";
import DiscountRedeemBar from "../components/DiscountRedeemBar/DiscountRedeemBar";

type Props = {
  data: DiscountsItem | undefined;
  imageUrl: string | undefined;
  itemCode: string;
  items: DiscountsItem[];
  selectedItemIndex: number;
  setSelectedItemIndex: (i: number) => void;
  brandName?: string;
};

const DiscountDetailsWeb: FC<Props> = ({ data, imageUrl, itemCode, items, selectedItemIndex, setSelectedItemIndex, brandName }) => {
  return (
    <div className="flex w-full gap-10">
      <div className="flex-5 flex flex-col gap-6">
        <div className="rounded-xs flex flex-col gap-6 p-6 shadow-sm">
          <div className="flex flex-col gap-4">
            <DiscountDetailsCard data={data} imageUrl={imageUrl} brandName={brandName} />
            <DiscountChips items={items} selectedItemIndex={selectedItemIndex} onSelect={setSelectedItemIndex} />
          </div>
          <Divider className="m-0!" />
          <DiscountRedeemBar data={data} imageUrl={imageUrl} itemCode={itemCode} />
        </div>
      </div>
      <div className="rounded-xs flex-2 shadow-sm">
        <Instructions termsAndConditions={data?.termsAndConditions ?? ""} usageInstructions={data?.usageInstructions ?? ""} />
      </div>
    </div>
  );
};

export default DiscountDetailsWeb;
